export type FlagValue = boolean;
export type FlagStore = Record<string, FlagValue>;
export type FlagChangeCallback = (flagName: string, value: FlagValue) => void;

export interface FlagEntry {
  name: string;
  value: boolean;
}

export interface FlagLoadOptions {
  merge?: boolean;
  updateDefaults?: boolean;
}

export interface FlagSource {
  loadFlags(): Promise<FlagStore | FlagEntry[]>;
}

export class APIFlagSource implements FlagSource {
  constructor(
    private url: string,
    private options?: RequestInit
  ) {}

  async loadFlags(): Promise<FlagStore | FlagEntry[]> {
    const response = await fetch(this.url, this.options);
    if (!response.ok) {
      throw new Error(`Failed to load flags from API: ${response.statusText}`);
    }
    return response.json();
  }
}

export class FileSystemFlagSource implements FlagSource {
  constructor(private modulePath: string) {}

  async loadFlags(): Promise<FlagStore | FlagEntry[]> {
    try {
      const flagsModule = await import(/* @vite-ignore */ this.modulePath);
      const flags = flagsModule.default || flagsModule.flags || flagsModule;
      return flags;
    } catch (error: unknown) {
      const errorMessage = error instanceof Error ? error.message : String(error);
      throw new Error(`Failed to load flags from file: ${errorMessage}`);
    }
  }
}